module.exports = __webpack_public_path__ + "img/signup-1.61f85530.png";